export const notProductCategoryName = "כללי";
